module.exports = __webpack_public_path__ + "121aac5b8d361b1d9e9199da7a93fe41.pdf";